import { Injectable } from '@angular/core';
import { AuthService } from '@app/services';
import { DataFieldGroup } from '@models/settings/data-field-group.model';

@Injectable()
export class CustomFieldsService {
    constructor(protected auth: AuthService) {}

    async saveFieldGroup(group: DataFieldGroup): Promise<DataFieldGroup> {
        if (group.isPersisted) {
            return group;
        }

        return await group.param('company', this.auth.company.id).save();
    }
}
